import { render, staticRenderFns } from "./AddRowsModal.vue?vue&type=template&id=33148b90&scoped=true&"
import script from "./AddRowsModal.vue?vue&type=script&lang=js&"
export * from "./AddRowsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddRowsModal.vue?vue&type=style&index=0&id=33148b90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33148b90",
  null
  
)

export default component.exports